import { render, staticRenderFns } from "./AcordionLike.vue?vue&type=template&id=7c5f72e2&scoped=true&"
import script from "./AcordionLike.vue?vue&type=script&lang=ts&"
export * from "./AcordionLike.vue?vue&type=script&lang=ts&"
import style0 from "./AcordionLike.vue?vue&type=style&index=0&id=7c5f72e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f72e2",
  null
  
)

export default component.exports